/**
 * Calulation functions for a-parameter calculation
 *
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import regression from 'regression';

const automatic_lookup_table = {
    "1.3":-0.000334,
    "1.31":-0.000334,
    "1.32":-0.000336,
    "1.33":-0.000337,
    "1.34":-0.000338,
    "1.35":-0.000339,
    "1.36":-0.000341,
    "1.37":-0.000342,
    "1.38":-0.000343,
    "1.39":-0.000344,
    "1.4":-0.000412,
    "1.41":-0.000408,
    "1.42":-0.000404,
    "1.43":-0.000400,
    "1.44":-0.000396,
    "1.45":-0.000392,
    "1.46":-0.000389,
    "1.47":-0.000392,
    "1.48":-0.000395,
    "1.49":-0.000398,
    "1.5":-0.000401,
    "1.51":-0.000404,
    "1.52":-0.000407,
    "1.53":-0.000409,
    "1.54":-0.000412,
    "1.55":-0.000415,
    "1.56":-0.000418,
    "1.57":-0.000421,
    "1.58":-0.000428,
    "1.59":-0.000433,
    "1.6":-0.000438,
    "1.61":-0.000444,
    "1.62":-0.000449,
    "1.63":-0.000454,
    "1.64":-0.000459,
    "1.65":-0.000465,
    "1.66":-0.000470,
    "1.67":-0.000473,
    "1.68":-0.000475,
    "1.69":-0.000478,
    "1.7":-0.000480,
    "1.71":-0.000690,
    "1.72":-0.000700,
    "1.73":-0.000720,
    "1.74":-0.000730,
    "1.75":-0.000720
}

function ref_at_T (ref_points: number[], T: number[]) {
    // let Tcoeffs = [-0.000336,-0.000337,-0.000339,-0.000342,-0.000412,-0.000404,-0.000392,-0.000392,-0.000401,-0.000407]

    let nD: number[] = [];

    ref_points.forEach((val, i) => {
        let coeff = automatic_lookup_table[val.toString() as keyof typeof automatic_lookup_table]
        let nD_at_T = val + coeff*(T[i]-25.0)
        // const numberArray = nD_at_T.toString().replace(',', '.').split('.')
        // const addDecimals = numberArray[1] ? numberArray[1].padEnd(6, '0') : '0000'
        nD.push(nD_at_T);
    });

    return nD;
}

function ccd_To_x_dimension(CCD: number[]) {
    let x: number[] = [];

    CCD.forEach((val, i) => {
        let xDim = val/50 - 1;
        x.push(xDim);
    });

    return x;
}

function fit_x(x: number[], nD: number[]) {
    let data: any = [];

    x.forEach((val, i) => {
        data[i] = [val, nD[i]];
    })

    const result = regression.polynomial(data, {order: 3, precision: 6});

    let aParams = result.equation.map((val: any, i: number) => {
        let res = Math.round(val * 65536)
        return res;
    })
    aParams[aParams.length-1] = aParams[aParams.length-1] - 65536;

    return aParams;
}

function CCD_to_nD(CCD: number[], A: number[]) {
    const a0 = A[3]
    const a1 = A[2]
    const a2 = A[1]
    const a3 = A[0]

    let x_vector: number[] = [];

    CCD.forEach((val, i) => {
        x_vector.push(val/50-1)
    });

    let nD_calc: number[] = []

    x_vector.forEach((val, i) => {
        nD_calc.push(1 + (a0 + a1*val + a2 * val**2 + a3 * val**3)/65536)
    });

    return nD_calc
}

function CCD_to_nD_Line(CCD: number[], A: number[]) {
    const a0 = A[3]
    const a1 = A[2]
    const a2 = A[1]
    const a3 = A[0]

    let x_vector: number[] = [];

    CCD.forEach((val, i) => {
        x_vector.push(val/50-1)
    });

    let nD_calc: number[] = []

    // x_vector.forEach((val, i) => {
    //     nD_calc.push(1 + (a0 + a1*val + a2 * val**2 + a3 * val**3)/65536)
    // });
    for (var val = -1; val < 1; val = val+0.01) {
        nD_calc.push(1 + (a0 + a1*val + a2 * val**2 + a3 * val**3)/65536)
    }

    return nD_calc
}

// function calculateAndPrintResults(ref_points: number[], CCD: number[], A: number[], nD: number[]) {

//     // const calculationsElement = document.getElementById('calculations');
//     // let parameters_no_water_point = document.createElement('p');
//     // parameters_no_water_point.innerHTML = `A parameters with no water point<br>________________________________<br>\ta0: ${A[3]} <br>\ta1: ${A[2]} <br>\ta2: ${A[1]} <br>\ta3: ${A[0]}`;
//     // calculationsElement.append(parameters_no_water_point)

//     console.log(`A parameters with no water point\n________________________________\n\ta0: ${A[3]} \n\ta1: ${A[2]} \n\ta2: ${A[1]} \n\ta3: ${A[0]}`)

//     const nD_calc = CCD_to_nD(CCD, A)

//     let delta: number[] = [];

//     nD.forEach((val, i) => {
//         delta.push(nD_calc[i] - val);
//     })

//     let pass_fail: string[] = [];

//     delta.forEach((val, i) => {
//         pass_fail.push(Math.abs(val) < 0.0004 ? "PASS" : "FAIL")
//     })

//     let header = document.createElement("h3");
//     let polynomial_fit_results = document.createElement('table');

//     header.innerHTML = "Polynomial fit result:<br>________________________";
//     polynomial_fit_results.innerHTML = `
//         <thead><th>Point</th><th>Ref</th><th>Meas</th><th>Delta</th></thead><tbody>
//     `;

//     ref_points.forEach((val, i) => {
//         polynomial_fit_results.innerHTML += `
//             <tr>
//                 <td>${val}</td>
//                 <td>${nD[i].toFixed(6)}</td>
//                 <td>${nD_calc[i].toFixed(6)}</td>
//                 <td>${(nD_calc[i] - nD[i]).toFixed(5)}</td>
//                 <td>${pass_fail[i]}</td>
//             </tr>
//         `;
//     })
//     polynomial_fit_results.innerHTML += `</tbody>`;

//     // calculationsElement.append(header);
//     // calculationsElement.append(polynomial_fit_results);

//     console.log("\nPolynomial fit result:\n________________________\n\tPoint, Ref,   Meas,       Delta")
//     ref_points.forEach((val, i) => {
//         console.log(`\t${val}, ${nD[i].toFixed(6)}, ${nD_calc[i].toFixed(6)}, ${(nD_calc[i] - nD[i]).toFixed(5)}, ${pass_fail[i]}`)
//     })

//     return nD_calc;
// }

export function get_CCD_and_nD(refpoints: number[], CCDvalues: number[], Tvalues: number[]) {

    const ref_points = refpoints
    const CCD = CCDvalues
    const T = Tvalues

    const nD = ref_at_T(ref_points, T);

    const x = ccd_To_x_dimension(CCD);

    const A = fit_x(x, nD);

    // const nD_calc = calculateAndPrintResults(ref_points, CCD, A, nD);
    const nD_calc = CCD_to_nD(CCD, A)
    const nD_calcLine = CCD_to_nD_Line(CCD, A)

    let CCD_calc: number[] = [];
    for (var val = -1; val < 1; val = val+0.01) {
        CCD_calc.push((val + 1) * 50)
    }

    return {
        "CCD": CCD,
        "nD_calc": nD_calc,
        "nD_calcLine": nD_calcLine,
        "nD": nD,
        "A": A,
        "CCD_calc": CCD_calc
    };

}
